import { Component, OnInit, Input } from '@angular/core';
/**
  Componente que muestra un video en la interfaz de usuario.
  Este componente permite cargar y reproducir un video desde la carpeta de assets,
  con dimensiones personalizables.
**/
@Component({
  selector: 'am-show-video',
  templateUrl: './am-show-video.component.html',
  styleUrls: ['./am-show-video.component.scss'],
  standalone: false,
})
export class AmShowVideoComponent implements OnInit {
  /**
    Nombre del archivo de video que se cargará desde la carpeta de assets.
    @type {string}
  **/
  @Input() fileName: string;

  /**
      Ancho del video en píxeles.
      @type {number}
      @default 800
    **/
  @Input() widthVideo = 800;

  /**
      Altura del video en píxeles.
      @type {number}
      @default 800
    **/
  @Input() heightVideo = 800;

  /**
      Clase CSS adicional que se aplicará al contenedor del video.
      @type {string}
      @default ''
    **/
  @Input() classStyle = '';

  /**
      Carpeta relativa dentro de assets donde se encuentra el video.
      Acepta con o sin slash final (ej. 'video', 'video/', 'ssbd', 'ssbd/').
      @type {string}
      @default 'video'
    **/
  @Input() folder = 'video';

  /**
      Ruta completa del archivo de video que se cargará.
      @type {string}
    **/
  srcComponent: string;

  constructor() {}

  ngOnInit(): void {
    const normalizedFolder = (this.folder || 'video').replace(/^\/+|\/+$/g, '');
    this.srcComponent = `./assets/${normalizedFolder}/${this.fileName}`;
  }
}
